import { List } from 'immutable';
import { AnalogTemperatureSensor, Z3KObject } from 'z3k-config';
import { useContext } from 'react';
import { Z3KSettingsEditor } from 'z3k-settings/provider/types';
export function useNtcSensorsState() {
    const { config } = useContext(Z3KSettingsEditor);
    const objectArrays = config?.object_arrays ?? [];
    const sensors = List(AnalogTemperatureSensor.get
        .all(config)
        .slice()
        .sort(Z3KObject.cmp_by_id)
        .map((sensor) => {
        const shift = Math.round(sensor.calibration_shift);
        return {
            id: sensor.id,
            name: sensor.name,
            original_shift: shift,
            shift: shift.toString(),
            setting_register: sensor.setting_register,
        };
    }));
    return { sensors, objectArrays };
}
